import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ConfigModule, StateConfig, StateTransferType } from '@spartacus/core';
import { PRODUCT_RECOMMENDATIONS_FEATURE } from './product-recommendations-state';
import { reducerProvider, reducerToken } from './reducers/product-recommendations.reducer';

function productRecommendationsStoreConfigFactory(): StateConfig {
  return {
    state: {
      ssrTransfer: {
        keys: {
          [PRODUCT_RECOMMENDATIONS_FEATURE]: StateTransferType.TRANSFER_STATE,
        },
      },
    },
  };
}

@NgModule({
  imports: [
    StoreModule.forFeature(PRODUCT_RECOMMENDATIONS_FEATURE, reducerToken),
    ConfigModule.withConfigFactory(productRecommendationsStoreConfigFactory),
  ],
  providers: [reducerProvider],
})
export class ProductRecommendationsStoreModule {}
